import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { StaticImage } from 'gatsby-plugin-image';
import Section from '../../../shared/Section/Section';
import { styles } from './styles';
import PointsList from '../../../shared/PointsList/PointsList';
import { sendYandexMetrikaEvent } from '../../../helpers/yandexMetrika';
import PrecourseCard from '../../../shared/PrecourseCard/PrecourseCard';
import { sendMyTargetEvent } from '../../../helpers/myTarget';

function FormatBootcamp({
  title,
  preCourseTitle,
  description,
  duration,
  link,
  startDate,
  pointsList,
  priceData,
}) {
  const isBelowMd = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const [isMediaQueryReady, setIsMediaQueryReady] = useState(false);
  useEffect(() => {
    if (!isMediaQueryReady) {
      setIsMediaQueryReady(true);
    }
  }, [isBelowMd]);
  if (!isMediaQueryReady) {
    return null;
  }
  const sendYmEventBuy = () => {
    sendYandexMetrikaEvent('WebDevPreCoursesBuy');
    sendMyTargetEvent('WebDevPreCoursesBuy');
  };
  return (
    <Section theme={isBelowMd ? 'light' : 'default'} withoutBg>
      <Grid
        container
        direction={{ xs: 'column', md: 'row' }}
        sx={styles.container}
      >
        <Grid item xs={12} lg={5.5} sx={styles.imgContainer}>
          <Typography variant="desktopH3" color={'kit.text.h'}>
            {title}
          </Typography>
          {isBelowMd && (
            <Typography
              variant="desktopP2"
              color={'kit.text.secondary'}
              sx={{ mt: 2 }}
            >
              {description}
            </Typography>
          )}
          <Box sx={styles.imgBox}>
            <StaticImage
              src="./images/bootcampFormat.png"
              alt="bootcamp format"
            />
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          lg={5}
          xl={5.5}
          sx={{
            zIndex: 0,
            ml: { xs: 'none', lg: 'auto' },
            mr: { xs: 'none', sm: 'auto', lg: 'none' },
          }}
        >
          <PrecourseCard
            link={link}
            title={preCourseTitle}
            isMobile={isBelowMd}
            description={description}
            priceData={priceData}
            startDate={startDate}
            duration={duration}
            pointsList={<PointsList list={pointsList} />}
            sendYmEventBuy={sendYmEventBuy}
          />
        </Grid>
      </Grid>
    </Section>
  );
}

export default FormatBootcamp;
